export default "__VITE_ASSET__Cle_0I3d__"